import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import PageTitleIcon from './PageTitleIcon';

export interface PageHeaderProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  meta?: React.ReactNode;
  footer?: React.ReactNode;
}

/**
 * Standard page header — matches Zero: icon badge + h4 title, optional subtitle,
 * actions on the right, and an optional footer row (e.g. tabs).
 */
const PageHeader: React.FC<PageHeaderProps> = ({
  icon,
  title,
  subtitle,
  action,
  meta,
  footer,
}) => (
  <Paper
    elevation={2}
    sx={{
      mb: 3,
      p: 3,
      borderRadius: '16px',
      display: 'flex',
      flexDirection: 'column',
      gap: footer ? 2 : 0,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
        <PageTitleIcon icon={icon} />
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h4" sx={{ fontWeight: 600, color: 'text.primary', lineHeight: 1.25 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.5 }}>
              {subtitle}
            </Typography>
          )}
          {meta && <Box sx={{ mt: 1 }}>{meta}</Box>}
        </Box>
      </Box>
      {action}
    </Box>
    {footer && (
      <Box sx={{ borderTop: 1, borderColor: 'divider', pt: 1 }}>
        {footer}
      </Box>
    )}
  </Paper>
);

export default PageHeader;
